import theme from 'src/theme';

export default {
  '@global': {
    html: {
      fontSize: theme.typography.fontSize,
    },

    body: {
      ...theme.typography.body1,

      margin: 0,
      padding: 0,
      fontSmoothing: 'antialiased',
    },

    code: {
      fontFamily: 'source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace',
    },

    h1: {
      ...theme.typography.h1,
    },

    h2: {
      ...theme.typography.h2,
    },

    h3: {
      ...theme.typography.h3,
    },

    h4: {
      ...theme.typography.h4,
    },

    h5: {
      ...theme.typography.h5,
    },

    h6: {
      ...theme.typography.h6,
    },
  },
};
